import { getSize } from '../iterable/getSize';

import { ERRORS, MAX_DESCRIPTION_LENGTH } from '../../constants/validations';
import { EBAY, ETSY, FAIRE } from '../../constants/channels';

export function getDescriptionError({ channel, value }) {
  switch (channel) {
    case EBAY:
    case ETSY:
    case FAIRE: {
      if (getSize(value) === 0) {
        return ERRORS.DESCRIPTION.REQUIRED;
      }

      if (getSize(value) > MAX_DESCRIPTION_LENGTH[channel]) {
        return ERRORS.DESCRIPTION.LENGTH_EXCEEDED[channel];
      }

      return false;
    }

    default: {
      return false;
    }
  }
}
